import {
  header_button_default
} from "./chunk-QMLW6FHI.mjs";

// src/internal/components/account-switch/account-switch.tsx
import * as React from "react";
import keyBy from "lodash.keyby";
import map from "lodash.map";
import partialRight from "lodash.partialright";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  MultiEntitySwitcher,
  useAuthContext
} from "@clara/auth";
import { ChevronDownIcon, ChevronUpIcon, CreateIcon } from "@clara/icons";
import { useT } from "@clara/locale";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  MenuFooter,
  Button,
  Avatar
} from "@clara/ui";
import { isEmptyArray } from "@clara/utils";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function AccountSwitch(props) {
  const { children, onCreateAccount, ...rest } = props;
  const { t } = useT("common");
  const { can_create_company } = useAuthContext();
  const placeholder = t("accountSwitch.create.label");
  const renderOption = (option, index, _array, offset = 0) => {
    const offsetIndex = index + offset;
    return /* @__PURE__ */ jsx(
      MenuItemOption,
      {
        value: option.companyUUID,
        id: String(offsetIndex),
        children: option.companyName || placeholder
      },
      option.companyUUID
    );
  };
  const render = (props2) => {
    const { value, onChange } = props2;
    let count = 0;
    const options = keyBy(props2.options, "label");
    return map(options, ({ label, ...group }) => {
      const groupProps = {
        key: label,
        title: t(`accountSwitch.${label}`),
        value: value == null ? void 0 : value.companyUUID,
        defaultValue: (value == null ? void 0 : value.companyUUID) || "",
        onChange: (uuid) => {
          if (uuid)
            onChange(String(uuid));
        },
        type: "picker"
      };
      const renderFn = partialRight(renderOption, count);
      count += group.options.length;
      if (isEmptyArray(group.options))
        return null;
      return /* @__PURE__ */ jsx(MenuOptionGroup, { ...groupProps, children: group == null ? void 0 : group.options.map(renderFn) });
    });
  };
  return /* @__PURE__ */ jsx(MultiEntitySwitcher, { ...rest, children: ({ value, options, onChange }) => /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, children: [
    props.children,
    /* @__PURE__ */ jsx(Menu, { children: ({ isOpen }) => /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(MenuButton, { children: (props2) => /* @__PURE__ */ jsx(
        header_button_default,
        {
          ...props2,
          leftIcon: !!(value == null ? void 0 : value.companyName) ? /* @__PURE__ */ jsx(Avatar, { size: "small", name: value == null ? void 0 : value.companyName }) : React.createElement(() => null),
          rightIcon: React.createElement(
            isOpen ? ChevronUpIcon : ChevronDownIcon,
            { fontSize: "small" }
          ),
          children: /* @__PURE__ */ jsx(
            Box,
            {
              component: "span",
              sx: {
                display: "block",
                pointerEvents: "none",
                flex: "1 1 auto",
                minW: 0,
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              children: (value == null ? void 0 : value.companyName) || placeholder
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(MenuList, { children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: (theme) => ({
              maxHeight: theme.spacing(300 / 8),
              overflowY: "scroll",
              position: "relative"
            }),
            children: render({
              options,
              value,
              onChange
            })
          }
        ),
        can_create_company && /* @__PURE__ */ jsx(MenuFooter, { children: /* @__PURE__ */ jsx(
          Button,
          {
            variant: "text",
            onClick: onCreateAccount,
            leftIcon: /* @__PURE__ */ jsx(CreateIcon, {}),
            children: t("accountSwitch.createNew")
          }
        ) })
      ] }) })
    ] }) })
  ] }) });
}

export {
  AccountSwitch
};
